import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import { FrontpageAlertData } from '@mwe/models';
import { FaqItem } from '../../model/faq-item.model';

@Injectable({
  providedIn: 'root',
})
export class IkpStaticContentService extends ApiService {
  getTemporaryAlert(): Observable<FrontpageAlertData> {
    return this.httpClient.get<FrontpageAlertData>(`${this.staticContentUrl}/config/frontpage-alert.json`);
  }

  getStaticFAQs(): Observable<FaqItem[]> {
    return this.httpClient.get<FaqItem[]>(`${this.staticContentUrl}/faq/faqs.json`);
  }
}
